import React, { useState } from "react";

import { getTextColor } from "@intelligems/ig-utils";
import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";
import { BackgroundIcon } from "../../../../ProgressBarView/icons/BackgroundIcon";
import { ProgressBarIcon } from "../../../../ProgressBarView/icons/ProgressBarIcon";
import { ProgressBarBreakpoint } from "../../../../ProgressBarView/types";
import { getBreakpointPosition } from "../../../../ProgressBarView/variants/version1/components/getBreakpointPosition";
import { Tooltip } from "../../../../ProgressBarView/variants/version1/components/Tooltip";

interface BreakpointProps {
  index: number;
  breakpoint: ProgressBarBreakpoint;
}

export const Breakpoint = (props: BreakpointProps) => {
  const { breakpoint } = props;
  const context = useProgressBarContext();
  const { device } = context;
  const [hovered, setHovered] = useState(false);
  const { activeColor, inactiveColor } = device.widget.styles.breakpoint;
  const activeIconColor = getTextColor(activeColor);
  const inactiveIconColor = getTextColor(inactiveColor);
  return (
    <Container
      {...props}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      className="ig-dp-breakpoint"
    >
      {breakpoint.progress >= 100 && (
        <span className="ig-dp-completed-breakpoint filled">
          <BackgroundIcon
            color={activeColor}
            id={breakpoint.active.backgroundIconId ?? "circle"}
          />
          <BreakpointIcon
            color={activeIconColor}
            id={breakpoint.active.iconId ?? "check"}
          />
        </span>
      )}
      {breakpoint.progress < 100 && (
        <span className="ig-dp-locked-breakpoint">
          <BackgroundIcon
            color={inactiveColor}
            id={breakpoint.inactive.backgroundIconId ?? "circle"}
          />
          <BreakpointIcon
            color={inactiveIconColor}
            id={breakpoint.inactive.iconId ?? "lockClosed"}
          />
        </span>
      )}
      {hovered && <Tooltip breakpoint={breakpoint} />}
    </Container>
  );
};

const Container = styled("span")(({ index, breakpoint }: BreakpointProps) => {
  const { state, device } = useProgressBarContext();
  const count = state.breakpoints.length;
  const { size } = device.widget.styles.breakpoint;

  const position = Math.round(100 * getBreakpointPosition(index, count));
  return {
    cursor: breakpoint.tooltipEnabled ? "pointer" : "auto",
    display: "block",
    position: "absolute",
    left: `calc(${position}% - ${0.5 * size}px)`,
    top: size / 2,
    width: size,
    height: size,
  };
});

const BreakpointIcon = styled(ProgressBarIcon)(() => {
  const { device } = useProgressBarContext();
  const { size } = device.widget.styles.breakpoint;
  const iconSize = 0.6 * size;
  return {
    position: "absolute",
    left: (size - iconSize) / 2,
    top: (size - iconSize) / 2,
    width: iconSize,
    height: iconSize,
  };
});
